import React from 'react';

const HerokuIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="70"
            height="70"
            viewBox="0 0 2500 2500"
        >
            <path fill="#6762a5" d="M0 0h2500v2500H0z"></path>
            <path
                fill="#fff"
                d="M1417.5 1969.9v-787.4s51.2-188.4-630.9 77.1c-1.2 3.4-1.2-728.2-1.2-728.2l222.9-1.4v468.7s624-245.8 624 186.4v784.8zm127-1156.2h-236.4c85.1-104 162.1-282.3 162.1-282.3h244.4c.1 0-41.8 116.2-170.1 282.3zM789.4 1968.6v-448.4l224.2 224.2z"
            ></path>
        </svg>
    );
};

export default HerokuIcon;